import { GAEvent, GAEventName, GAUserContext } from '../interfaces/googleAnalytics'
import { logger } from '../logger'
import { fetchEnv } from '../utils/fetchEnv'

const GA_ENDPOINT = 'https://www.google-analytics.com/mp/collect'
const GA_DEBUG_ENDPOINT = 'https://www.google-analytics.com/debug/mp/collect'

// Get via https://developers.google.com/analytics/devguides/collection/protocol/ga4/sending-events?client_type=gtag#recommended_parameters_for_reports
const MEASUREMENT_ID = fetchEnv('GA4_MEASUREMENT_ID')
const API_SECRET = fetchEnv('GA4_SECRET')

export class GoogleAnalytics {
  debug: boolean
  clientId: string
  sessionId: string

  constructor(clientId: string, sessionId: string, debug = false) {
    this.debug = debug
    this.clientId = clientId
    this.sessionId = sessionId
  }

  async fireEvent(name: GAEventName, eventData: GAEvent, userContext: GAUserContext | undefined) {
    const userProperties =
      userContext &&
      Object.fromEntries(Object.entries(userContext).map(([key, value]) => [key, { value }]))

    let url = this.debug ? GA_DEBUG_ENDPOINT : GA_ENDPOINT
    url += `?measurement_id=${MEASUREMENT_ID}&api_secret=${API_SECRET}`

    try {
      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          client_id: this.clientId,
          user_properties: userProperties,
          events: [
            {
              name,
              params: {
                session_id: this.sessionId,
                engagement_time_msec: 100,
                ...eventData,
              },
            },
          ],
        }),
      })

      if (this.debug) {
        console.log(await response.text())
      }
    } catch (e) {
      logger.error('Google Analytics request failed with an exception', {
        originalError: e,
      })
    }
  }
}
